/**
 * @prettier
 * @flow
 */
import apisauce from 'apisauce';
import { terminalApiCode } from 'src/api/terminalApiCode';
import { terminalApiUrl } from 'src/api/terminalApiUrl';
import type { ApiSauceRequest } from 'src/api/types/ApiSauceRequest';
import type { ApiSauceResponse } from 'src/api/types/ApiSauceResponse';
import type { PushTerminalInstructionRequest } from 'src/api/types/terminalPosApi/PushTerminalInstructionRequest';
import { appVersion } from 'src/config/appVersion';
import { environment } from 'src/config/environment';
import type { Environment } from 'src/constants/Environment';
import type { TerminalInstructionReceivedResult } from 'src/constants/TerminalInstructionReceivedResult';
import type { TerminalInstructionId } from 'src/types/Id';

const REQUEST_METHODS_WITH_PARAMS = ['get', 'head', 'delete', 'link', 'unlink'];

function createTerminalPosApi(environment: Environment) {
    const baseURL = `${terminalApiUrl(environment)}/api/pos`;

    const api = apisauce.create({
        baseURL,
        headers: {
            'Content-Type': 'application/json',
        },
        timeout: 60000, // 60 second timeout
    });

    if (process.env.NODE_ENV === 'development') {
        api.addRequestTransform(request => {
            const other = {};
            // if (request.headers) {
            //     other.headers = request.headers;
            // }
            if (request.params) {
                other.params = request.params;
            }
            if (request.data) {
                other.data = request.data;
            }
            console.log(`${request.method.toUpperCase()} ${baseURL}${request.url}`, other);
        });
        api.addMonitor((response) => {
            console.log(`${response.status} <- ${response.config.url}`, response.data);
        });
    }

    api.addRequestTransform(request => {
        if (REQUEST_METHODS_WITH_PARAMS.includes(request.method)) {
            if (!request.params) request.params = {};
            request.params.appVersion = appVersion;
        } else {
            if (!request.data) request.data = {};
            if (!request.params) request.params = {};
            request.data.appVersion = appVersion;
        }
    });

    return {
        config: api,
        pushTerminalInstruction: (request: ApiSauceRequest<PushTerminalInstructionRequest>): ApiSauceResponse<TerminalInstructionId | void> => {
            const { environment, serverUrl, ...req } = request;
            return api.post('api/pos/pushTerminalInstruction', req, { baseURL: serverUrl, params: { code: terminalApiCode(environment) } });
        },
        pushTerminalInstructionV2: (request: ApiSauceRequest<PushTerminalInstructionRequest>): ApiSauceResponse<{ terminalInstructionId: TerminalInstructionId, result: TerminalInstructionReceivedResult } | void> => {
            const { environment, serverUrl, ...req } = request;
            return api.post('api/pos/pushTerminalInstructionV2', req, { baseURL: serverUrl, params: { code: terminalApiCode(environment) } });
        },
    };
}

export const terminalPosApi = createTerminalPosApi(environment);
